import {Drawer} from '@breuni-ui/drawer';
import {safeDefine} from "@breuni-ui/safe-define";
import {togglePageScrolling} from "../../scripts/utils.js";

export class EntsDrawer extends Drawer {
  show(): void {
    this.registerCloseListener();
    togglePageScrolling(false);
    this.removeAttribute('hidden');
    super.show();
  }

  async hide(): Promise<void> {
    togglePageScrolling(true);
    this.unregisterCloseListener();
    await super.hide();
    this.setAttribute('hidden', '');
  }

  private registerCloseListener() {
    document.addEventListener('keydown', () => this.handleEsc);
    this.addEventListener('drawer:close', this.hide);
  }

  private unregisterCloseListener() {
    document.removeEventListener('keydown', () => this.handleEsc);
    this.removeEventListener('drawer:close', this.hide);
  }

  private handleEsc(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }
}

safeDefine('ents-drawer', EntsDrawer);
